import { render, staticRenderFns } from "./user.html?vue&type=template&id=270b0c8d&scoped=true&"
import script from "./user.js?vue&type=script&lang=js&"
export * from "./user.js?vue&type=script&lang=js&"
import style0 from "./user.scss?vue&type=style&index=0&id=270b0c8d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270b0c8d",
  null
  
)

export default component.exports